export const role = {
  role_list_title: 'Roles list',
  role_translation_title: 'Roles translations',
  role_title: 'Role title',
  load_translation_error: 'Translations loading has failed'
};
